/** Max characters of body included on the error for logs and clients. */
const PREVIEW = 500;

/**
 * Thrown when `internalFetch` receives a response whose body is not valid JSON
 * (including HTML error pages such as Cloudflare challenge / rate-limit text).
 *
 * `status` / `statusText` are from the **HTTP response of the request to the given `url`**
 * (e.g. api.derivws.com or auth.deriv.com), not from your application server.
 */
export default class DerivHttpError extends Error {
    constructor({ url, status, statusText = '', bodyText = '', parseError = null }) {
        const trimmed = typeof bodyText === 'string' ? bodyText.trim() : '';
        const preview = trimmed.slice(0, PREVIEW);
        const dots = trimmed.length > PREVIEW ? '…' : '';
        const parseMsg =
            parseError instanceof Error ? parseError.message : parseError != null ? String(parseError) : 'invalid JSON';

        super(
            `HTTP ${status}${statusText ? ` ${statusText}` : ''} ${url} — body is not JSON (${parseMsg}): ${preview}${dots}`
        );

        this.name = 'DerivHttpError';
        this.url = url;
        this.status = typeof status === 'number' ? status : 0;
        this.statusText = statusText || '';
        this.bodyPreview = preview;
        this.bodyLength = typeof bodyText === 'string' ? bodyText.length : 0;

        // Preserve parse failure for tooling
        /** @type {unknown} */
        this.parseError = parseError;
    }
}
